import React from "react";
import { MDBContainer } from "mdbreact";

// CSS imports
import "./Dashboard.css";

export default function AdminDashboard() {
  return <MDBContainer>DASHBOARD</MDBContainer>;
}
